import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useAppDispatch } from '@/store';
import { createPompiste, updatePompiste } from '@/store/thunks/pompisteThunks';
import type { Pompiste } from '@/types';
import { Input, Button } from '@/components/ui';

const schema = Yup.object({
  nom: Yup.string().required('Nom obligatoire'),
  prenom: Yup.string().required('Prénom obligatoire'),
});

interface PompisteFormProps {
  pompiste?: Pompiste | null;
  type: 'create' | 'update';
  onClose: () => void;
  onSuccess?: () => void;
}

export default function PompisteForm({ pompiste, type, onClose, onSuccess }: PompisteFormProps) {
  const dispatch = useAppDispatch();

  const formik = useFormik({
    initialValues: {
      nom: pompiste?.nom ?? '',
      prenom: pompiste?.prenom ?? '',
    },
    validationSchema: schema,
    onSubmit: async (values) => {
      if (type === 'update' && pompiste?.id) {
        const res = await dispatch(updatePompiste({ ...pompiste, ...values }));
        if (updatePompiste.fulfilled.match(res)) {
          onSuccess?.();
          onClose();
        }
      } else {
        const res = await dispatch(createPompiste(values));
        if (createPompiste.fulfilled.match(res)) {
          onSuccess?.();
          onClose();
        }
      }
    },
  });

  return (
    <form onSubmit={formik.handleSubmit} className="space-y-4">
      <Input
        label="Nom"
        id="nom"
        {...formik.getFieldProps('nom')}
        error={formik.touched.nom ? formik.errors.nom : undefined}
      />
      <Input
        label="Prénom"
        id="prenom"
        {...formik.getFieldProps('prenom')}
        error={formik.touched.prenom ? formik.errors.prenom : undefined}
      />
      <div className="flex justify-end gap-2 pt-2">
        <Button type="button" variant="outline" onClick={onClose}>Annuler</Button>
        <Button type="submit" loading={formik.isSubmitting}>{type === 'update' ? 'Modifier' : 'Créer'}</Button>
      </div>
    </form>
  );
}
